import { Icon } from '@iconify/react';
import { useState } from 'react';

const CartCleanupNotification = ({ cleanup }) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!cleanup || !cleanup.removed_count || cleanup.removed_count === 0 || !isVisible) {
    return null;
  }

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
      <div className="flex items-start justify-between">
        <div className="flex items-start">
          <Icon icon="feather:info" className="h-5 w-5 text-blue-600 mt-0.5 mr-3 flex-shrink-0" />
          <div className="flex-1">
            <h4 className="text-sm font-medium text-blue-800 mb-1">Keranjang Telah Dibersihkan</h4>
            <p className="text-sm text-blue-700 mb-2">
              {cleanup.removed_count} item yang sudah dibeli telah dihapus dari keranjang Anda.
            </p>

            {cleanup.removed_purchased_items?.length > 0 && (
              <div className="space-y-1">
                <p className="text-xs text-blue-600 font-medium">Item yang dihapus:</p>
                {cleanup.removed_purchased_items.slice(0, 3).map((item, index) => (
                  <div key={index} className="text-xs text-blue-600">
                    • {item.title || item.name}
                  </div>
                ))}
                {cleanup.removed_purchased_items.length > 3 && (
                  <div className="text-xs text-blue-600">
                    • dan {cleanup.removed_purchased_items.length - 3} item lainnya
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <button
          onClick={() => setIsVisible(false)}
          className="text-blue-400 hover:text-blue-600 ml-2"
          aria-label="Tutup notifikasi"
        >
          <Icon icon="feather:x" className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default CartCleanupNotification;
